import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { debitsSelectedComp } from "../actions";


export const checkDebitsExist = (props) => {
  if(props.debitsSelectedValue.length === 0){
    const { from } = props.location.state || {
      from: { pathname: "/" }
    };
    props.history.push(from);
  }
}

const mapStateToProps = store => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ debitsSelectedComp }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(checkDebitsExist);